import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-nr-ait',
  templateUrl: './text-nr-ait.component.html',
  styleUrls: ['./text-nr-ait.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNrAitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
